import React, { useEffect } from 'react';
import ProductsPage from '../pages/ClientPanel/Products'
import { BrowserRouter, Routes, Route, useNavigate } from 'react-router-dom';
import LoginScreen from '../pages/Login/Login';
import PrivateRoute from './PrivateRouter';
import Validation from '../pages/Login/Validation';
import CompleteRegister from '../pages/Login/CompleteRegister';
import SuccessMsg from '../pages/Login/SuccessMsg';
import AdminRegister from '../pages/Login/AdminRegister';
import ClientPanel from '../pages/ClientPanel';
import HomeScreen from '../pages/ClientPanel/Home';
import CertificatesContent from '../pages/ClientPanel/Certificates';
import StockContent from '../pages/ClientPanel/Stock';
import ProductionFlow from '../pages/ClientPanel/ProductionFlow';
import PeopleContent from '../pages/ClientPanel/Accesses';
import OrdersContent from '../pages/ClientPanel/Orders';
import ServicesTable from '../pages/ClientPanel/ProductionFlow/ServicesTable';
import PCPGrid from '../pages/ClientPanel/ProductionFlow/PCPGrid';
import StagesTable from '../pages/ClientPanel/ProductionFlow/StagesTable';
import CreateOPModal from '../components/Services/CreateServiceModal';
import AddOpInPcp from '../components/ModalWithoutColumns';
import StockTable from '../pages/ClientPanel/Stock/StockTable';
import MovementTable from '../pages/ClientPanel/Stock/MovementsTable';
import TableAccesses from '../pages/ClientPanel/Accesses/AccessesTable';
import TableProfile from '../pages/ClientPanel/Accesses/ProfilesTable';
import CompaniesContent from '../pages/ClientPanel/Companies';
import NotFoundPage from '../pages/SystemErrors/NotFound';
import SteelOrders from '../pages/ClientPanel/SteelOrders';
import CreateOrder from '../pages/ClientPanel/SteelOrders/AddOrder';
import SteelOrdersTable from '../pages/ClientPanel/SteelOrders/SteelOrdersTable';
import ModalTest from '../components/BaseModal';
import ViewSteelOrder from '../pages/ClientPanel/SteelOrders/ViewSteelOrder';
import CertificatesTable from '../pages/ClientPanel/Certificates/CertificateTable';
import CreateCertificate from '../pages/ClientPanel/Certificates/CreateCertificate';
import ParamTable from '../pages/ClientPanel/Certificates/ParamTable';
import CreateParam from '../pages/ClientPanel/Certificates/CreateParam';
import ViewCertificateModal from '../components/Certificates/ViewCertificateModal';
import MachinesTable from '../pages/ClientPanel/ProductionFlow/MachinesTable';
import EquipmentContent from '../pages/ClientPanel/Equipment';
import EquipmentTable from '../pages/ClientPanel/Equipment/Machines/EquipmentTable';
import RegisterEquipment from '../pages/ClientPanel/Equipment/Machines/RegisterEquipment';
import EditEquipment from '../pages/ClientPanel/Equipment/Machines/EditEquipment';
import VehicleTable from '../pages/ClientPanel/Equipment/Vehicles/VehicleTable';
import ViewOPCard from '../components/Modals/ViewPCP'
import RouterTable from '../pages/ClientPanel/router/routerTable'
import RouterSection from '../pages/ClientPanel/router'
import RouterContent from '../pages/ClientPanel/router/index2'
import FreightTable from '../pages/ClientPanel/router/freightTable'
import DateAndTimeTable from '../pages/ClientPanel/router/dateAndTimeTable'
import NewRouter from '../pages/ClientPanel/router/newRouter'
import FreightContent from '../components/routerModal/freightContent'
import VehicleContent from '../components/routerModal/vehicleContent'
import VehicleForm from '../components/routerModal/vehicleContent/vehicleForm'
import VehicleDetail from '../components/routerModal/vehicleContent/vehicleDetail'
import FreightForm from '../components/routerModal/freightContent/freightForm'
import FreightDetail from '../components/routerModal/freightContent/freightDetail'
import RouterDetail from '../components/routerModal/routerContent/routerDetail'
import FashionContent from '../pages/ClientPanel/FashionOrders'
import FashionOrdersTable from '../pages/ClientPanel/FashionOrders/FashionOrdersTable'
import AddFashionOrder from '../pages/ClientPanel/FashionOrders/AddOrder'
import EditFashionOrder from '../pages/ClientPanel/FashionOrders/EditOrder'
import ProductionFashionContent from '../pages/ClientPanel/ProductionFashion'
import ProductionFashionTable from '../pages/ClientPanel/ProductionFashion/ProductionTable'
import PCPDashboard from '../pages/ClientPanel/ProductionFashion/PCPDashboard'
import AddFashionOP from '../pages/ClientPanel/ProductionFashion/AddFashionOP'
import ServicesContent from '../pages/ClientPanel/Services'
import ResourcesContent from '../pages/ClientPanel/Resources'
import CreateResourceModal from '../components/Modals/Resource/CreateResource'
import StageServicesTable from '../pages/ClientPanel/Services/ServicesTable'
import ResourcesTable from '../pages/ClientPanel/Resources/ResourcesTable'
import CreateServiceModal from '../components/Modals/ServiceStage/CreateServiceModal'
import ViewServiceStageModal from '../components/Modals/ServiceStage/ViewServiceStageModal'
import ViewResourceModal from '../components/Modals/Resource/ViewResource'

const ClientPanelLayout = () => (
  <PrivateRoute>
    <ClientPanel />
  </PrivateRoute>
);


const Router = () => {
  return (
    <BrowserRouter basename='/'>
      <Routes>
        {/** Rotas Públicas */}
        <Route path='/' element={<LoginScreen />} />
        <Route path='/accessvalidation' element={<Validation />} />
        <Route path='/pendingmessage' element={<SuccessMsg />} />
        <Route path='/completeRegister' element={<CompleteRegister />} />
        <Route path='/internalaccess/:token' element={<AdminRegister />} />

        {/** Rotas Privadas dentro do ClientPanel */}
        <Route path='*' element={<NotFoundPage />} />
        <Route path='/panel' element={<ClientPanelLayout />}>
          <Route path='*' element={<NotFoundPage />} />
          <Route index element={<HomeScreen />} />
          <Route path='certificates' element={<CertificatesContent />}>
            <Route index element={<CertificatesTable />} />
            <Route path='view/' element={<ViewCertificateModal />}/>
            <Route path='create' element={<CreateCertificate />} />
            <Route path='edit' element={<CreateCertificate />} />
            <Route path='params' element={<ParamTable />} />
            <Route path='params/create' element={<CreateParam />}/>
            <Route path='params/edit' element={<CreateParam />} />
          </Route>
          <Route path='stock' element={<StockContent />}>
            <Route index element={<StockTable />} />
            <Route path='movement' element={<MovementTable />} />
          </Route>
          <Route path='production' element={<ProductionFlow />}>
            <Route index element={<PCPGrid />} />
            <Route path='card' element={<ViewOPCard />} />
            <Route path='pcp/:stageId' element={<AddOpInPcp />} />
            <Route path='services' element={<ServicesTable />} />
            <Route path='services/create' element={<CreateOPModal />} />
            <Route path='stages' element={<StagesTable />} />
            {/* <Route path='stages/create' element={} /> */}
          </Route>
          <Route path='fashion' element={<FashionContent />}>
            <Route index element={<FashionOrdersTable />}/>
            <Route path='create' element={<AddFashionOrder />}/>
            <Route path='edit/:orderId' element={<EditFashionOrder />}/>
          </Route>
          <Route path='production-fashion' element={<ProductionFashionContent />}>
            <Route index element={<ProductionFashionTable />}/>
            <Route path='pcp' element={<PCPDashboard />}/>
            <Route path='pcp/create' element={<AddFashionOP />}/>
          </Route>
          <Route path='people' element={<PeopleContent />}>
            <Route index element={<TableAccesses />} />
            <Route path='profiles' element={<TableProfile />} />
          </Route>
          <Route path='equipment' element={<EquipmentContent />}>
            <Route index element={<EquipmentTable />} />
            <Route path='register' element={<RegisterEquipment />} />
            <Route path='edit/:machineId' element={<EditEquipment />} />
            <Route path='vehicles' element={<VehicleTable />} />
          </Route>
          <Route path='orders' element={<OrdersContent />} />
          <Route path='steel' element={<SteelOrders />} >
            <Route index element={<SteelOrdersTable />} />
            <Route path=':orderId' element={<ViewSteelOrder />} />
            <Route path='create' element={<CreateOrder />} />
            <Route path='products' />
          </Route>
          <Route path='companies' element={<CompaniesContent />} />
          <Route path='service' element={<ServicesContent />}>
            <Route index element={<StageServicesTable />} />
            <Route path='create' element={<CreateServiceModal />} />
            <Route path='edit' element={<CreateServiceModal />} />
            <Route path='view' element={<ViewServiceStageModal />} />
          </Route>
          <Route path='resource' element={<ResourcesContent />}>
            <Route index element={<ResourcesTable />} />
            <Route path='create' element={<CreateResourceModal />} />
            <Route path='edit' element={<CreateResourceModal />} />
            <Route path='view' element={<ViewResourceModal />} />
          </Route>
          <Route path='mach' element={<MachinesTable />} />

          <Route path='router' element={<RouterContent />}>
            <Route index element={<FreightTable />} />
            <Route path='create' element={<FreightForm />} />
            <Route path=':freightId' element={<FreightDetail />} />
            {/* <Route path='freights' element={<FreightTable/>}/> */}
            <Route path='routers' element={<RouterTable />} />
            <Route path='dateAndTime' element={<DateAndTimeTable />} />
            <Route path='routers/create' element={<NewRouter />} />
            <Route path='routers/:routerId' element={<RouterDetail />} />
            <Route path='routers/edit' element={<NewRouter />} />
            {/* <Route path='teste' element={<RouterSection/>}/> */}
          </Route>
          <Route path='equipment' element={<EquipmentContent />}>
            <Route index element={<VehicleTable />} />
            <Route path='create' element={<VehicleForm />} />
            <Route path=':vehicleId' element={<VehicleDetail />} />
            {/* <Route path='vehicles' element={<VehicleTable/>}/> */}
            {/* Ajustar quando a tela de máquinas tiver pronta */}
          </Route>
          <Route path='products' element={<ProductsPage />} />
        </Route>

      </Routes>
    </BrowserRouter>
  );
};

export default Router;
